<template>
  <article id="readings">
    <h2>Readings</h2>
    <ul v-if="readings">
      <li v-for="(reading, idx) in readings" :key="idx">
        <a v-if="reading.link && reading.link !== ''" :href="reading.link" v-html="reading.title"></a>
        <span v-else v-html="reading.title"></span>

        <span v-if="reading.extra && reading.extra !== ''" v-html="reading.extra"></span>
      </li>
    </ul>
    <slot/>
  </article>
</template>

<script>
export default {
  props: ['readings']
}
</script>



// WEBPACK FOOTER //
// src/components/global/submodule/partial/Readings.vue